export default {
	title: "Brazil Transactions",
	subtitle: "",
  path: "transaction_brazil",
	paragraph: '',
	request:  {}
}


// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionBrazil.js